import React, { createContext, useContext, useState } from "react";

const LandingContext = createContext({
    showLanding: false,
    setShowLanding: () => {},
});

export const LandingProvider = ({ children }) => {
    const [showLanding, setShowLanding] = useState(() => {
        const hasVisited = sessionStorage.getItem("hasVisitedLanding");
        return !hasVisited;
    });

    return (
        <LandingContext.Provider value={{ showLanding, setShowLanding }}>
            {children}
        </LandingContext.Provider>
    );
};

export const useLanding = () => useContext(LandingContext);
